module.exports = __webpack_public_path__ + "static/media/g-icon-arrow_right.2dc608f8.svg";